// 3rd Party
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'opencare-crown';

import {
  validatePromoCode,
  updateValidatePromoCodeError,
} from 'connect/actions';

import { FlexCol, H3, P } from 'common/styles/oc-styled-components';

import { colors } from 'common/styles/style-constants';

import { useOfferService } from 'services/OfferService';

import { selectValidatePromoCodeError } from '../../../../connect/selectors';

// Components
import GiftConfettiSvg from '../../../common/components/svgs/GiftConfettiSvg';

import { StyledInput } from '../../../legacy-checkout/checkout-styled-components';

import { StyledModal, StyledRedInput } from './styled-components';

// Other

const AddPromoCodeModal = ({
  addPromoCodeModalIsVisible,
  setAddPromoCodeVisibility,
}) => {
  const dispatch = useDispatch();
  const offerService = useOfferService();

  const error = useSelector(selectValidatePromoCodeError);
  const [code, setCode] = useState('');

  const hasPromoCode = offerService.isPromoCode && offerService.hasActiveOffer;

  const updateCode = newCode => {
    setCode(newCode);
  };

  const validateCouponCode = e => {
    e.preventDefault();
    dispatch(validatePromoCode(code));
  };

  useEffect(() => {
    if (hasPromoCode) {
      setAddPromoCodeVisibility(false);
    }
  }, [hasPromoCode]);

  const InputComponent = error ? StyledRedInput : StyledInput;
  return (
    <StyledModal
      footer={null}
      onCancel={e => {
        e.preventDefault();
        dispatch(updateValidatePromoCodeError(undefined));
        setCode('');
        setAddPromoCodeVisibility(false);
      }}
      visible={addPromoCodeModalIsVisible}
    >
      <GiftConfettiSvg height="100px" width="100px" />
      <FlexCol align="center" justify="space-between">
        <H3 fontSize="20px">Please enter promo code</H3>
        <P color={colors.gray8}>eg. EXAMPLE50</P>
        <form onSubmit={validateCouponCode} data-testid="promoCodeSubmit">
          <InputComponent
            height="auto"
            fontSize="18px"
            fontWeight="300"
            margin="20px 0 10px"
            padding="12px 16px"
            placeholder="Promo code"
            size="large"
            onChange={e => updateCode(e.target.value)}
            value={code}
            data-testid="promoCodeInput"
          />
          {error
            ?             (
              <P color={colors.danger} data-testid="promoCodeError">
                {error}
              </P>
            )
            :             (
              <P color={colors.gray8} margin="0 0 10px 0">
                One promo code per new patient
              </P>
            )
          }

          <Button
            type="primary"
            size="large"
            shape="round"
            block
            htmlType="submit"
            disabled={code === ''}
          >
            Submit
          </Button>
        </form>
      </FlexCol>
    </StyledModal>
  );
};

AddPromoCodeModal.propTypes = {
  addPromoCodeModalIsVisible: PropTypes.bool,
  setAddPromoCodeVisibility: PropTypes.func,
};

export default AddPromoCodeModal;
